import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import * as React from "react";
import { FormProvider as RcFormProvider } from "rc-field-form1.26";
import { useContext } from "react";
import { useMemo } from "react";
// import type { ColProps } from '../grid/col';

import omit from "../../hack/rc-util/omit";
import { jsx as _jsx } from "react/jsx-runtime";
export var FormContext = /*#__PURE__*/React.createContext({
  labelAlign: "right",
  vertical: false,
  itemRef: function () {}
});

/** `noStyle` Form Item Context. Used for error collection */

export var NoStyleItemContext = /*#__PURE__*/React.createContext(null);

/** Form Provider */

export var FormProvider = function FormProvider(props) {
  var providerProps = omit(props, ["prefixCls"]);
  return /*#__PURE__*/_jsx(RcFormProvider, _objectSpread({}, providerProps));
};

/** Used for ErrorList only */

export var FormItemPrefixContext = /*#__PURE__*/React.createContext({
  prefixCls: ""
});
export var FormItemInputContext = /*#__PURE__*/React.createContext({});
export var NoFormStatus = function NoFormStatus(_ref) {
  var children = _ref.children;
  var emptyContext = useMemo(function () {
    return {};
  }, []);
  return /*#__PURE__*/_jsx(FormItemInputContext.Provider, {
    value: emptyContext,
    children: children
  });
};
export var NoFormStyle = function NoFormStyle(_ref2) {
  var children = _ref2.children,
    status = _ref2.status,
    override = _ref2.override;
  var formItemInputContext = useContext(FormItemInputContext);
  var newFormItemInputContext = useMemo(function () {
    var newContext = _objectSpread({}, formItemInputContext);
    if (override) {
      delete newContext.isFormItemInput;
    }
    if (status) {
      delete newContext.status;
      delete newContext.hasFeedback;
      delete newContext.feedbackIcon;
    }
    return newContext;
  }, [status, override, formItemInputContext]);
  return /*#__PURE__*/_jsx(FormItemInputContext.Provider, {
    value: newFormItemInputContext,
    children: children
  });
};